class MFRQuiz {
  constructor(index, element) {
    this.$index = index
    this.$element = $(element)

    this.$quizTrigger = this.$element.find('.quiz-trigger')
    this.$quizCloseTrigger = this.$element.find('.close')

    this.init()
  }

  init() {
    this.setQuizWidgetCookie()
    this.quizWidgeVisibility()

    this.$quizCloseTrigger.on('click', this.hideQuizWidget.bind(this))
  }

  hideQuizWidget(event) {
    window.setCookie('showQuizWidget', false, 1)
    $(event.currentTarget).parents('.quiz-trigger').hide() 
  }

  quizWidgeVisibility() {
    if (this.showQuizWidget) {
      this.$quizTrigger.show()
    } else {
      this.$quizTrigger.hide()
    }
  }

  setQuizWidgetCookie() {
    if ( !window.getCookie('showQuizWidget') ) {
      window.setCookie('showQuizWidget', true, 1)
    }

    this.showQuizWidget = JSON.parse(window.getCookie('showQuizWidget'))
  }
}